import * as store from "store";
import { JOURNAL_DATA } from "../constants/journal";
import { $, $$ } from "../utils/dom";
import { NOT_FIRST_VISIT_KEY } from "./../constants/not-first-visit-key";
import { Modal } from "./modal";
import { Template } from "./template";

export interface ISetting {
  [key: string]: boolean;
}

export class Setting {
  private static singleton: Setting;
  public $button: HTMLButtonElement;
  public event: Event;

  private template: Template;
  private $allSetting: HTMLInputElement[];
  private settingKey: string;
  private modal: Modal;

  constructor() {
    this.settingKey = "%%__SETTING__%%";
    this.template = new Template("#js__template--setting");
    this.modal = Modal.instance;
    this.$button = $("#js__setting") as HTMLButtonElement;
    this.event = new Event("settingUpdate");
  }

  public init() {
    this.generate();
    this.$button.addEventListener("click", this.handleClick.bind(this));
  }

  public save() {
    const $allSetting = $$(
      '.swal-modal input[type="checkbox"]'
    ) as HTMLInputElement[];
    const settingJson = $allSetting.reduce((obj: ISetting, el) => {
      obj[el.id] = el.checked;
      return obj;
    }, {});
    store.set(this.settingKey, JSON.stringify(settingJson));
  }

  public load() {
    const setting = this.get();
    if (!setting) {
      return;
    }
    const $allSetting = $$(
      '#js__template--setting input[type="checkbox"]'
    ) as HTMLInputElement[];
    const keys = Object.keys(setting);
    if (!keys.length) {
      return;
    }
    for (const key in setting) {
      if (typeof setting[key] === "boolean") {
        const element = this.template.$(`#${key}`) as HTMLInputElement;
        if (element) {
          element.checked = setting[key];
        }
      }
    }
  }

  public get() {
    try {
      if (!store.get(this.settingKey)) {
        return null;
      }
      const setting: ISetting = JSON.parse(store.get(this.settingKey));
      if (!setting) {
        return null;
      }
      return setting;
    } catch (err) {
      return null;
    }
  }

  public getOne(str: string) {
    const setting = this.get();
    if (!setting) {
      return null;
    }
    return setting[str];
  }

  private generate() {
    const svg = `<svg class="svg svg-icon swal-checkbox" viewBox="0 0 20 20">
    <path d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" style="stroke: white;fill:white;"></path>
  </svg>`;
    const $ul = this.template.$(".journals") as HTMLUListElement;
    const $lis = Object.keys(JOURNAL_DATA).map(abbr => {
      const { canAchieve, full } = JOURNAL_DATA[abbr];
      return `<li class="swal-list pretty p-svg p-curve p-smooth">
        <input id="js__${abbr}" class="useSciHub" type="checkbox" ${
        canAchieve ? "" : "checked"
      }>
        <div class="state p-success">
          ${svg}
          <label class="swal-text swal-text-config" for="js__${abbr}">${full}</label>
        </div>
      </li>`;
    });
    $ul.innerHTML = $lis.join("");
  }

  private handleClick() {
    this.load();
    this.modal.show("setting").then(options => {
      if (options === "clear") {
        this.modal.show("cacheClear");
        store.clearAll();
        store.set(NOT_FIRST_VISIT_KEY, true);
        $$("a.resolved").forEach(($a: HTMLAnchorElement) => {
          $a.className = "pending";
          $a.href = "#";
        });
      }
      this.save();
      window.dispatchEvent(this.event);
      this.update();
    });
  }

  private update() {
    const setting = this.get();
    if (!setting) {
      return;
    }
  }

  /**
   * Creates an unique instance of AppComponent
   *
   * @readonly
   * @static
   * @type {AppComponent}
   * @memberof AppComponent
   */
  public static get instance(): Setting {
    if (!Setting.singleton) {
      Setting.singleton = new Setting();
    }
    return Setting.singleton;
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/components/setting.ts